import React from "react";

import { makeStyles, createStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";
import { CarModel } from "leasemojo-common";

const useStyles = makeStyles((theme: Theme) =>
  createStyles(
    {
      image: {
        width: 60,
      },
    }
  ),
);

interface Props {
  model: CarModel,
  size?: number;
}

const ModelImage: React.FC<Props> = ({ model, size }) => {
  const classes = useStyles();
  const styles = size ? {
    width: size,
  } : {};
  return (
    <img style={styles} className={classes.image} src={`${process.env.REACT_APP_CDN_BASE_CARS}/${model.imageUrl}`} alt={model.name} />
  );
};

export default ModelImage;